import { render, staticRenderFns } from "./AddDetail.vue?vue&type=template&id=0cf77e5b"
import script from "./AddDetail.vue?vue&type=script&lang=js"
export * from "./AddDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports